"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _merchant = require("@/api/merchant");
var _batteryType = require("@/api/iot/batteryType");
var _setmeal = require("@/api/iot/setmeal");
var _default = {
  props: ['editItem'],
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        merchant_id: '',
        name: '',
        // deposit_pay_type: '',
        // remark: '',
        // deposit: 0,
        status: 1,
        spec: []
      },
      spec: {
        id: '',
        spec_name: '',
        battery_type_id: 0,
        original_price: '',
        price: '',
        lease_time: '',
        free_times: '',
        status: 1
      },
      merchantList: [],
      batteryTypeList: [
        // {
        //     id: 0,
        //     battery_type: '全部',
        // },
      ],
      terminalStateList: [{
        id: 1,
        label: '运营中'
      }, {
        id: 2,
        label: '库存'
      }, {
        id: 3,
        label: '测试中'
      }, {
        id: 4,
        label: '维护中'
      }],
      rules: {
        merchant_id: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入套餐名称',
          trigger: 'blur'
        }]
      },
      specRules: {
        spec_name: [{
          required: true,
          message: '请输入规格名称',
          trigger: 'blur'
        }],
        original_price: [{
          required: true,
          message: '请输入原价',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0.01,
          message: '价格必须大于0',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入价格',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0.01,
          message: '价格必须大于0',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '换电套餐';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            for (var key in _this.form) {
              if (key == 'spec') {
                _this.form[key] = _this.initSpec((0, _toConsumableArray2.default)(_this.editItem[key]));
              } else {
                _this.form[key] = _this.editItem[key];
              }
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getBatteryTypeList();
  },
  methods: {
    initSpec: function initSpec(specList) {
      var _this2 = this;
      var list = [];
      specList.forEach(function (item) {
        var spec = (0, _objectSpread2.default)({}, _this2.spec);
        for (var key in spec) {
          spec[key] = item[key];
        }
        list.push(spec);
      });
      return list;
    },
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    addSpec: function addSpec() {
      this.form.spec.push((0, _objectSpread2.default)({}, this.spec));
    },
    delSpec: function delSpec(index) {
      this.form.spec.splice(index, 1);
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getBatteryTypeList: function () {
      var _getBatteryTypeList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res, _this$batteryTypeList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _batteryType.batteryTypeList)();
              case 2:
                res = _context2.sent;
                if (res.data) {
                  (_this$batteryTypeList = this.batteryTypeList).push.apply(_this$batteryTypeList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getBatteryTypeList() {
        return _getBatteryTypeList.apply(this, arguments);
      }
      return getBatteryTypeList;
    }(),
    submit: function () {
      var _submit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this3 = this;
        var valid, len, i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.$refs['specForm']) {
                  _context3.next = 3;
                  break;
                }
                this.$func.isError('请添加套餐规格');
                return _context3.abrupt("return");
              case 3:
                _context3.next = 5;
                return this.$refs['form'].validate().catch(function (err) {});
              case 5:
                valid = _context3.sent;
                len = this.$refs['specForm'].length;
                i = 0;
              case 8:
                if (!(i < len)) {
                  _context3.next = 19;
                  break;
                }
                if (!valid) {
                  _context3.next = 15;
                  break;
                }
                _context3.next = 12;
                return this.$refs['specForm'][i].validate().catch(function (err) {});
              case 12:
                valid = _context3.sent;
                _context3.next = 16;
                break;
              case 15:
                i = len;
              case 16:
                i++;
                _context3.next = 8;
                break;
              case 19:
                if (!valid) {
                  _context3.next = 23;
                  break;
                }
                (0, _setmeal.setmealSave)(this.form).then(function (res) {
                  _this3.dialogVisible = false;
                  _this3.$emit('getList');
                });
                _context3.next = 25;
                break;
              case 23:
                this.$message({
                  message: '请检查表单错误',
                  type: 'error'
                });
                return _context3.abrupt("return", false);
              case 25:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }
};
exports.default = _default;